import { Component, OnInit ,ViewChild, Input} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
declare var $: any;

@Component({ 
  selector: 'sw-global-search-index',
  templateUrl: './sw-global-search-index.component.html',
  styleUrls: ['./sw-global-search-index.component.css']
})
export class SwGlobalSearchIndexComponent implements OnInit {

  /**
   * datas 为全局搜索导航栏 
   *  datas: any = [
   * { clusterName: '', text: '全部' },
   * { clusterName: 'cms', searchMap: { "type": "archives" }, text: '资讯' }]
   */
  @Input() datas:any = []
    /**
   * globalSearchUrl 为全局搜索主页面要跳转的搜索详情页面 
   */
  @Input() globalSearchUrl:string=''
  /**
   * title 为全局搜索主页面要跳转的搜索详情页面的title名称
   */
  @Input() title:string='全文检索'
   /**
   * type 为全局搜索主页面布局类型
   * type为1：条件布局在查询输入框上
   * type为2：条件以下拉框的形式在搜索输入框前面
   * type为3：检索输入框聚焦点时，条件出现
   */
  @Input() type:number= 1

  active: number = 0; //当前选中的下标
  searchDatas: any ={
    searchValue:'', //input输入的值
    data:{}, //点击的当前类型对象
    active:0 //当前选中的下标
  }; //检索的对象
  searchValue: string //输入的检索值
  dropDownText: string =''; //样式2时 选择下拉框获取的对应text值
  isDisplaySearch: boolean = false; //样式3时  是否显示带有条件的搜索样式 默认不显示
  constructor(
    private router: Router,
    private activedRouter: ActivatedRoute,
  ) { 
 
  }

  ngOnInit() {
    this.dropDownText = this.datas[0].text
  }
  //样式3 聚焦搜索框时 出现带条件的样式
  onDisplay() {
    this.isDisplaySearch = true
  }
   //样式3 取消搜索框时 关闭带条件的样式
   closeDisplay() {
    this.isDisplaySearch = false
    this.active = 0;
    this.searchValue = ''
  }
  //点击下拉框 获取对应数据
  clickSearch(item,i) {
    this.dropDownText = item.text
    this.active = i;
  }
 /**
   * 键盘enter键 全局搜索
   */
  enterSelect(event) {
    if(event.keyCode == 13) {
       this.toFullTextSearch()
    }
  }

  toFullTextSearch() {
    this.searchDatas = {
      searchValue: this.searchValue,
      data: this.datas[this.active],
      active: this.active,
      type: this.type
    }
    this.router.navigate([this.globalSearchUrl], {
      queryParams: {Title:this.title,data:JSON.stringify(this.searchDatas)}
    });
  }
 










 

 
}
